import React from 'react';
import { UserIcon, DollarSignIcon, BrainIcon, TimerIcon, TagIcon, HeartIcon } from 'lucide-react';
import { useClosingAssistant } from '../../contexts/ClosingAssistantContext';
export const CustomerProfilePanel: React.FC = () => {
  const {
    customerProfile
  } = useClosingAssistant();
  const renderDecisionStyle = (style: string) => {
    switch (style) {
      case 'analytical':
        return 'Analytical - Focuses on data and details';
      case 'emotional':
        return 'Emotional - Driven by feelings and experiences';
      case 'collaborative':
        return 'Collaborative - Seeks input from others';
      case 'directive':
        return 'Directive - Makes quick, independent decisions';
      default:
        return 'Unknown - Not enough data yet';
    }
  };
  const renderPriceLevel = (level: string) => {
    switch (level) {
      case 'budget':
        return 'Budget-conscious - Prioritizes value';
      case 'moderate':
        return 'Moderate - Balanced price/quality consideration';
      case 'luxury':
        return 'Luxury - Prioritizes premium experiences';
      default:
        return 'Unknown - Not enough data yet';
    }
  };
  return <div className="p-4" data-id="element-881">
      <div className="flex items-center mb-4" data-id="element-882">
        <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-883">
          <UserIcon className="h-5 w-5 text-blue-600" data-id="element-884" />
        </div>
        <div data-id="element-885">
          <h3 className="font-medium text-gray-800" data-id="element-886">Customer Profile</h3>
          <p className="text-xs text-gray-500" data-id="element-887">
            AI-generated behavioral analysis
          </p>
        </div>
      </div>
      <div className="space-y-4" data-id="element-888">
        {/* Decision making style */}
        <div className="border border-gray-200 rounded-lg p-3" data-id="element-889">
          <div className="flex items-center mb-2" data-id="element-890">
            <BrainIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-891" />
            <h4 className="text-sm font-medium text-gray-700" data-id="element-892">
              Decision Style
            </h4>
          </div>
          <p className="text-sm text-gray-600" data-id="element-893">
            {renderDecisionStyle(customerProfile.decisionStyle)}
          </p>
        </div>
        {/* Price sensitivity */}
        <div className="border border-gray-200 rounded-lg p-3" data-id="element-894">
          <div className="flex items-center mb-2" data-id="element-895">
            <DollarSignIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-896" />
            <h4 className="text-sm font-medium text-gray-700" data-id="element-897">
              Price Sensitivity
            </h4>
          </div>
          <p className="text-sm text-gray-600" data-id="element-898">
            {renderPriceLevel(customerProfile.priceLevel)}
          </p>
        </div>
        {/* Pace preference */}
        <div className="border border-gray-200 rounded-lg p-3" data-id="element-899">
          <div className="flex items-center mb-2" data-id="element-900">
            <TimerIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-901" />
            <h4 className="text-sm font-medium text-gray-700" data-id="element-902">
              Pace Preference
            </h4>
          </div>
          <p className="text-sm text-gray-600" data-id="element-903">
            {customerProfile.pacePreference === 'fast' ? 'Fast - Quick decision maker' : customerProfile.pacePreference === 'moderate' ? 'Moderate - Balanced approach' : customerProfile.pacePreference === 'slow' ? 'Deliberate - Thorough researcher' : 'Unknown - Not enough data yet'}
          </p>
        </div>
        {/* Interests */}
        <div className="border border-gray-200 rounded-lg p-3" data-id="element-904">
          <div className="flex items-center mb-2" data-id="element-905">
            <HeartIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-906" />
            <h4 className="text-sm font-medium text-gray-700" data-id="element-907">Key Interests</h4>
          </div>
          {customerProfile.interests.length > 0 ? <div className="space-y-2" data-id="element-908">
              {customerProfile.interests.sort((a, b) => b.level - a.level).slice(0, 3).map((interest, index) => <div key={index} className="flex items-center justify-between" data-id="element-909">
                    <span className="text-sm text-gray-600" data-id="element-910">
                      {interest.section}
                    </span>
                    <div className="flex items-center" data-id="element-911">
                      <div className="w-24 h-2 bg-gray-200 rounded-full mr-2" data-id="element-912">
                        <div className="h-2 bg-blue-500 rounded-full" style={{
                  width: `${interest.level}%`
                }} data-id="element-913"></div>
                      </div>
                      <span className="text-xs text-gray-500" data-id="element-914">
                        {interest.level}%
                      </span>
                    </div>
                  </div>)}
            </div> : <p className="text-sm text-gray-500" data-id="element-915">
              No significant interests detected yet
            </p>}
        </div>
        {/* Potential objections */}
        <div className="border border-gray-200 rounded-lg p-3" data-id="element-916">
          <div className="flex items-center mb-2" data-id="element-917">
            <TagIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-918" />
            <h4 className="text-sm font-medium text-gray-700" data-id="element-919">
              Potential Objections
            </h4>
          </div>
          {customerProfile.objections.length > 0 ? <ul className="space-y-1" data-id="element-920">
              {customerProfile.objections.map((objection, index) => <li key={index} className="text-sm text-gray-600" data-id="element-921">
                  • {objection}
                </li>)}
            </ul> : <p className="text-sm text-gray-500" data-id="element-922">
              No potential objections detected yet
            </p>}
        </div>
      </div>
    </div>;
};